/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./api";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const transactionsDynamicSearch = /* GraphQL */ `query TransactionsDynamicSearch(
  $material: String!
  $size: String!
  $countryOfOrigin: String!
  $quality: String!
  $fromTimestamp: Float
  $toTimestamp: Float
  $type: String
  $location: String
  $customsStatus: String
  $reason: String
  $source: String
  $nextToken: String
) {
  transactionsDynamicSearch(
    material: $material
    size: $size
    countryOfOrigin: $countryOfOrigin
    quality: $quality
    fromTimestamp: $fromTimestamp
    toTimestamp: $toTimestamp
    type: $type
    location: $location
    customsStatus: $customsStatus
    reason: $reason
    source: $source
    nextToken: $nextToken
  ) {
    items {
      id
      createdTimestamp
      commandId
      material
      size
      countryOfOrigin
      quality
      location
      transactionType
      action
      bondedQuantity
      nonBondedQuantity
      flowId
      businessReference
      source
      comment
      reason
      trigger
      flowType
      detail
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TransactionsDynamicSearchQueryVariables,
  APITypes.TransactionsDynamicSearchQuery
>;
export const inventoryDynamicSearch = /* GraphQL */ `query InventoryDynamicSearch(
  $material: String
  $size: String
  $countryOfOrigin: String
  $quality: String
  $imbalanceFilter: String
  $nextToken: String
) {
  inventoryDynamicSearch(
    material: $material
    size: $size
    countryOfOrigin: $countryOfOrigin
    quality: $quality
    imbalanceFilter: $imbalanceFilter
    nextToken: $nextToken
  ) {
    items {
      material
      size
      countryOfOrigin
      quality
      location
      bondedQuantity
      nonBondedQuantity
      snapshotDiff
      lastSuccessWmsSnapshotQuantity1060
      lastSuccessWmsSnapshotTimestamp1060
      lastSuccessWmsSnapshotQuantity1065
      lastSuccessWmsSnapshotTimestamp1065
      lastSuccessWmsSnapshotQuantity1067
      lastSuccessWmsSnapshotTimestamp1067
      lastSuccessWmsSnapshotQuantity1064
      lastSuccessWmsSnapshotTimestamp1064
      lastSuccessWmsSnapshotQuantity1264
      lastSuccessWmsSnapshotTimestamp1264
      lastSuccessLedgerSnapshotTimestamp
      lastSuccessLedgerSnapshotQuantity
      wmsSnapshotQuantity
      ledgerSnapshotQuantity
      ledgerSnapshotTimestamp
      balancingTimestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.InventoryDynamicSearchQueryVariables,
  APITypes.InventoryDynamicSearchQuery
>;
export const entryContextFallbackSearch = /* GraphQL */ `query EntryContextFallbackSearch {
  entryContextFallbackSearch {
    items {
      entryContextKey
      material
      size
      mco
      quality
      determinedUnitPrice
      calculationTimestamp
      entryTriggerType
      entryTimestamp
      flowId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EntryContextFallbackSearchQueryVariables,
  APITypes.EntryContextFallbackSearchQuery
>;
export const inventoryDetailSearch = /* GraphQL */ `query InventoryDetailSearch(
  $material: String!
  $size: String!
  $countryOfOrigin: String!
  $quality: String!
) {
  inventoryDetailSearch(
    material: $material
    size: $size
    countryOfOrigin: $countryOfOrigin
    quality: $quality
  ) {
    items {
      material
      size
      countryOfOrigin
      quality
      location
      bondedQuantity
      nonBondedQuantity
      snapshotDiff
      lastSuccessWmsSnapshotQuantity1060
      lastSuccessWmsSnapshotTimestamp1060
      lastSuccessWmsSnapshotQuantity1065
      lastSuccessWmsSnapshotTimestamp1065
      lastSuccessWmsSnapshotQuantity1067
      lastSuccessWmsSnapshotTimestamp1067
      lastSuccessWmsSnapshotQuantity1064
      lastSuccessWmsSnapshotTimestamp1064
      lastSuccessWmsSnapshotQuantity1264
      lastSuccessWmsSnapshotTimestamp1264
      lastSuccessLedgerSnapshotTimestamp
      lastSuccessLedgerSnapshotQuantity
      wmsSnapshotQuantity
      ledgerSnapshotQuantity
      ledgerSnapshotTimestamp
      balancingTimestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.InventoryDetailSearchQueryVariables,
  APITypes.InventoryDetailSearchQuery
>;
export const listTransactionsFieldSearch = /* GraphQL */ `query ListTransactionsFieldSearch($fieldName: String) {
  listTransactionsFieldSearch(fieldName: $fieldName) {
    items
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTransactionsFieldSearchQueryVariables,
  APITypes.ListTransactionsFieldSearchQuery
>;
export const getInventoryQuantityBySkuContainerBol = /* GraphQL */ `query GetInventoryQuantityBySkuContainerBol(
  $material: String
  $size: String
  $countryOfOrigin: String
  $quality: String
  $container: String
  $bol: String
) {
  getInventoryQuantityBySkuContainerBol(
    material: $material
    size: $size
    countryOfOrigin: $countryOfOrigin
    quality: $quality
    container: $container
    bol: $bol
  )
}
` as GeneratedQuery<
  APITypes.GetInventoryQuantityBySkuContainerBolQueryVariables,
  APITypes.GetInventoryQuantityBySkuContainerBolQuery
>;
export const getInventoryReports = /* GraphQL */ `query GetInventoryReports {
  getInventoryReports {
    reportS3Bucket
    reportRegion
    balancingReports {
      location
      reports {
        path
        version
        __typename
      }
      __typename
    }
    stockReports {
      location
      reports {
        path
        version
        __typename
      }
      __typename
    }
    stockContainerBolReports {
      location
      reports {
        path
        version
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInventoryReportsQueryVariables,
  APITypes.GetInventoryReportsQuery
>;
export const getDashboard = /* GraphQL */ `query GetDashboard {
  getDashboard {
    unitsCreated {
      year
      month
      trigger
      actualCustomsStatus
      totalAmount
      __typename
    }
    unitsRemoved {
      year
      month
      trigger
      actualCustomsStatus
      totalAmount
      __typename
    }
    manualCorrections {
      year
      month
      customsStatus
      action
      numberOfUnits
      __typename
    }
    insufficientInventoryCreated {
      year
      month
      customsStatus
      triggeredBy
      numberOfUnits
      __typename
    }
    unexpectedReceipts {
      year
      month
      action
      customsStatus
      numberOfUnits
      __typename
    }
    alternativeDeterminationEntries {
      year
      month
      alternativeValuationMethod
      numberOfEntries
      numberOfUnits
      __typename
    }
    amountOfFallbackEntriesPerTrigger {
      year
      month
      trigger
      customsStatus
      numberOfEntries
      numberOfUnits
      __typename
    }
    dutiesSaved {
      year
      month
      dutiesSaved
      dutiesUsed
      __typename
    }
    dutiesLiabilityIndication {
      location
      dutiesUsed
      dutyLiabilityIndication
      __typename
    }
    dutiesSavedNetting {
      year
      month
      dutiesUsed
      dutiesSaved
      units
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDashboardQueryVariables,
  APITypes.GetDashboardQuery
>;
